import { defineComponent as d, inject as v, computed as y, createElementBlock as h, openBlock as s, mergeProps as a, unref as n, createBlock as k, resolveDynamicComponent as I, withCtx as S, renderSlot as b } from "vue";
import m from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/SimpleList/simple-list.js";
import { SimpleListValueKey as C } from "./SimpleList.vue2.js";
import { useOUIAProps as L } from "../../helpers/ouia.js";
const w = /* @__PURE__ */ d({
  name: "PfSimpleListItem",
  __name: "SimpleListItem",
  props: {
    value: {},
    component: { default: "button" },
    componentClass: {},
    componentAttrs: {},
    type: { default: "button" },
    href: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["click"],
  setup(r, { emit: p }) {
    const t = r, l = L({ id: t.ouiaId, safe: t.ouiaSafe }), c = p, i = Symbol(), o = v(C, void 0), u = y(() => (o == null ? void 0 : o.value) === (t.value ?? i));
    function f(e) {
      c("click", e), o && (o.value = t.value ?? i);
    }
    return (e, B) => (s(), h("li", a(n(l), { class: "pf-v6-c-simple-list__item" }), [
      (s(), k(I(e.component), a(e.componentAttrs, {
        class: [n(m).simpleListItemLink, e.componentClass, {
          [n(m).modifiers.current]: u.value
        }],
        "aria-hidden": "true",
        type: e.component === "button" ? e.type : void 0,
        href: e.component === "a" ? e.href : void 0,
        tabindex: e.component === "a" ? 0 : void 0,
        onClick: f
      }), {
        default: S(() => [
          b(e.$slots, "default")
        ]),
        _: 3
      }, 16, ["class", "type", "href", "tabindex"]))
    ], 16));
  }
});
export {
  w as default
};
